import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser } from '../../../shared/interfaces/user.interface';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { Observable } from 'rxjs/internal/Observable';
import { ILogChangePassword } from '../interfaces/log-change-password.interface';
import { ITypeDocument } from '../interfaces/type-document.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  constructor(private _http: HttpClient) { }

  getList(queries: string): Observable<ApiResponse<IUser[]>> {
    return this._http.get<ApiResponse<IUser[]>>(`${environment.apiUrl}/users?${queries}`);
  }

  getById(id: string): Observable<ApiResponse<IUser[]>> {
    return this._http.get<ApiResponse<IUser[]>>(`${environment.apiUrl}/users/${id}`);
  }

  add(user: any, passwordConfirmation: string) : Observable<IUser> {
    user.passwordConfirmation = passwordConfirmation;
    return this._http.post<IUser>(`${environment.apiUrl}/users/add`, user);
  }

  edit(user: IUser) : Observable<any> {
    return this._http.patch<any>(`${environment.apiUrl}/users/${user.id}`, user);
  }

  delete(userId: string) : Observable<IUser> {
    return this._http.delete<IUser>(`${environment.apiUrl}/users/${userId}`);
  }

  changePassword(userId: string, password: string, confirmation: string, actualPassword: string = '') : Observable<any> {
    return this._http.put<any>(`${environment.apiUrl}/users/updatePassword/${userId}`,{
      password: password,
      confirmation: confirmation,
      actualPassword: actualPassword
    });
  }

  export(query: any) {
    return this._http.get<any>(
      `${environment.apiUrl}/users/export?${query}`,
      {
        responseType: 'blob' as 'json'
      }
    );
  }

  getLogPassword(queries: string): Observable<ApiResponse<ILogChangePassword[]>> {
    return this._http.get<ApiResponse<ILogChangePassword[]>>(`${environment.apiUrl}/users/log-password?${queries}`);
  }

  getListTypeDocuments(): Observable<ApiResponse<ITypeDocument[]>> {
    return this._http.get<ApiResponse<ITypeDocument[]>>(`${environment.apiUrl}/users/type-documents`);
  }

  getProfiles(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(`${environment.apiUrl}/profiles`);
  }

  getAreas(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(`${environment.apiUrl}/areas/id-name`);
  }

  getStates(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(`${environment.apiUrl}/geography/states`);
  }

  getCities(stateId: string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(`${environment.apiUrl}/geography/cities-by-state/${stateId}`);
  }

  getCitiesSameState(cityId: string): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(`${environment.apiUrl}/geography/cities-same-state/${cityId}`);
  }

  exportData(query: string): Observable<ApiResponse<IUser[]>> {
    return this._http.get<ApiResponse<IUser[]>>(`${environment.apiUrl}/users/export?${query}`);
  }

  import(file: any) {
    return this._http.post<any>(`${environment.apiUrl}/users/import`, file);
  }

  importGetErrors(fileExtension = 'xlsx'){
    return this._http.get<any>(`${environment.apiUrl}/users/import/errors?fileExtension=${fileExtension}`,
      {
        responseType: 'blob' as 'json'
      }
    );
  }
}
